import React, { Component } from "react";
import "./loading.css";
import bars from "./loadingBars.svg";

class Loading extends Component {
  state = {};

  render() {
    return (
      <div className="ontario-covid-viz-loading">
        <img className="bars" src={bars} alt="Bar Animation" />
        {/* <img id="graph" src={graph} alt="Graph Lines" />
        <div className="loader"></div> */}
      </div>
    );
  }
}

export default Loading;
